import { loginMap } from '@/api';
import { get, post } from '@/common/request';

class Login {
  login(params: any) {
    return post(loginMap.get('login'), params, { proxyApi: '/mirage', needHint: true });
  }

  logout() {
    return get(loginMap.get('logout'), {}, { proxyApi: '/mirage', needHint: true });
  }
};

export default new Login();
